export default "__VITE_ASSET__DQZFkBeE__"